import { Line } from "fabric";
import { getCanvas } from "./CanvasManager";

class AlignmentManager {

  private vertical: Line | null = null;
  private horizontal: Line | null = null;

  private snapDistance = 8;

  showCenterGuides() {

    const canvas = getCanvas();

    if (!canvas) return;

    this.hideGuides();

    this.vertical = new Line(
      [canvas.width! / 2, 0, canvas.width! / 2, canvas.height!],
      {
        stroke: "#00bfff",
        strokeWidth: 1,
        selectable: false,
        evented: false,
        excludeFromExport: true,
      }
    );

    this.horizontal = new Line(
      [0, canvas.height! / 2, canvas.width!, canvas.height! / 2],
      {
        stroke: "#00bfff",
        strokeWidth: 1,
        selectable: false,
        evented: false,
        excludeFromExport: true,
      }
    );

    canvas.add(this.vertical);
    canvas.add(this.horizontal);

    canvas.renderAll();
  }

  snap(object: any) {

    const canvas = getCanvas();

    if (!canvas) return;

    const centerX = canvas.width! / 2;
    const centerY = canvas.height! / 2;

    if (Math.abs((object.left ?? 0) - centerX) < this.snapDistance) {
      object.left = centerX;
    }

    if (Math.abs((object.top ?? 0) - centerY) < this.snapDistance) {
      object.top = centerY;
    }

  }

  hideGuides() {

    const canvas = getCanvas();

    if (!canvas) return;

    if (this.vertical) {
      canvas.remove(this.vertical);
      this.vertical = null;
    }

    if (this.horizontal) {
      canvas.remove(this.horizontal);
      this.horizontal = null;
    }

    canvas.renderAll();
  }
}

export const alignmentManager = new AlignmentManager();